import { render, staticRenderFns } from "./OsRecipientsOverview.vue?vue&type=template&id=3339dbf5&scoped=true"
import script from "./OsRecipientsOverview.vue?vue&type=script&lang=ts"
export * from "./OsRecipientsOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3339dbf5",
  null
  
)

export default component.exports